module.exports = __webpack_public_path__ + "static/convidi_macbook-f6894d2795a5f61f5e30f889688cb974.png";